import { Command } from '@/app/common/base/command'

export class ResetPasswordCommand extends Command {

    public async run(token: string, password: string) {
        await this.client.post('/api/auth/reset-password', { token, password })
    }

}
